/**Dependencies */
import React from "react";

/**Components */
import { Button, Modal } from "react-bootstrap";

// Styles
import "../styles/components/ModalTerminos.scss";
import openpay from "../images/openpay.png";
export const ModalTerminos = ({ openModal, setOpenModal }) => {
  return (
    <>
      <Modal
        size="xl"
        show={openModal}
        onHide={() => setOpenModal}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Políticas de Privacidad y Cancelación
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          paddingRight: "1rem"
        }}>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>LICENCIA</h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <a href="https://marzahtravel.com">https://marzahtravel.com</a> EL
            CLIENTE reconoce que la empresa “Marzah Travel AGENCIA DE VIAJES,
            (en lo sucesivo Marzah Travel) actúa como agencia de servicios
            turísticos nacionales y del extranjero, así como intermediaria entre
            usuarios-turistas y de otros prestadores de servicios turísticos
            entre sí, también respecto de la comercialización de paquetes
            turísticos, servicios turísticos, paquetes de viajes a través de
            medios electrónicos, portales digitales, páginas web, “e-commerce”
            (tiendas en línea o internet), realizar reservaciones, integración,
            desarrollo, operación y compraventa de paquetes turísticos, tanto de
            transporte aéreo, terrestre, marítimo por cuenta propia o de
            terceros, al igual presta el servicio a los usuarios-turistas
            servicios de orientación, asesoría, reservación y adquisición de
            boletos, nacionales o en el extranjero, los cuales estarán sujetos a
            los términos y condiciones especificados por los prestadores de
            servicios contratados, incluyendo de manera enunciativa más no
            limitadas, cargos por cancelaciones, pérdida devuelos, pérdida de
            equipaje, entre otros. Los mencionados servicios serán
            proporcionados por prestadores independientes que no actúan por o en
            representación de “Marzah Travel”, y en este acto, EL CLIENTE se
            hace expresamente conocedor de esta situación, así mismo acepta que
            ni “Marzah Travel”, ni sus subsidiarias, filiales, controladoras o
            representantes tienen injerencia alguna en la presentación de los
            servicios que ha contratado. En este acto EL CLIENTE libera a
            “Marzah Travel”, así como a sus accionistas, consejeros, afiliadas,
            subsidiarias, asesores, factores, dependientes, o partes
            relacionadas, de todo tipo de responsabilidad generada con motivo de
            cualquier incumplimiento, hecho, acto omisión, accidente o lesión
            vinculada y/o derivada de los servicios que ha contratado EL
            CLIENTE, incluyendo daños y perjuicios, ya sean directos,
            indirectos, incidentales, económicos, y/o negligentes, así como
            pérdidas, costos o gastos que pudieren ser generados con motivo o en
            relación a los servicios contratados a través de “Marzah Travel”.
            <br />
            <br />
            Toda reservación de hotel, paquetes, vuelos, expedición de boletos,
            traslados, guías y demás son no reembolsables. Para reservar los
            paquetes, en su mayoría se requiere de un depósito que puede variar
            de acuerdo con el operador, destino, o temporada en que se quiere
            viajar. Los depósitos no son reembolsables en caso de cualquier
            cancelación, según políticas del operador responsable.
            <br />
            <br />
            Los boletos de avión de cualquier categoría ofrecidos por la empresa
            son:
            <br />
            <br />
            <ul>
              <li>No reembolsables.</li>
              <li>No endosables.</li>
              <li>
                No transferibles (esto quiere decir que no se aceptan cambios de
                nombres). Todas las aerolíneas se reservan el derecho de
                sobrevender, cambiar horarios, e incluso cancelar o realizar
                cambios que ellos consideren pertinentes sin previo aviso y sin
                responsabilidad de “Marzah Travel”; esto está autorizado
                gubernamentalmente.
              </li>
            </ul>
            <br />
            <br />
            Así mismo, todas las líneas aéreas y navieras por medidas de
            seguridad tienen restricciones diferentes para que viajen menores de
            18 años, mujeres embarazadas y personas que utilicen bastón o silla
            de ruedas; por lo que EL CLIENTE acepta que es su responsabilidad
            consultar las restricciones aplicables a cada línea aérea o naviera.
            EL CLIENTE acepta que “Marzah Travel”, no es responsable de estas
            restricciones. Todos los viajeros deberán contar con la
            documentación necesaria para realizar su viaje; pasaportes vigentes,
            visas, siendo de su total responsabilidad los problemas e
            inconvenientes que puedan surgir por incumplimientos de este
            requerimiento. Los cambios o cancelación de los viajes ocasionados
            por causas originadas por huracanes, ciclones, terremotos o
            cualquier otra, son ajenos a “Marzah Travel”, y quedarán sujetos a
            las políticas y lineamientos de la línea aérea, transportista u
            operador para la cancelación total de viaje o cambios de itinerario.
            Los reembolsos parciales o totales dependerán de la línea aérea,
            transportista u operador.
            <br />
            <br />
            El CLIENTE acepta que para realizar cualquier trámite o aclaración
            deberá presentar el ticket de compra y/o factura, y la nota de
            pedido que contiene los datos de su viaje. Así mismo EL CLIENTE
            acepta que la(s) persona(s) que realizan la contratación de los
            servicios son las personas que firman y aceptan la hoja de
            condiciones generales y la(s) única(s) facultada(s) para realizar
            las aclaraciones o reclamaciones.
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            CAUSALES DE RESCISIÓN Y CONSECUENCIAS JURÍDICAS:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            El fundamento legal se encuentra acorde a lo establecido por los
            artículos 1794 al 1859 del Código Civil Federal, artículos del 89 al
            95 del Código de Comercio, artículos 76 bis y 76 bis 1 de la Ley
            Federal de Protección al Consumidor y bajo la recomendación de la
            Norma Mexicana NMX-COE-001-SCFI-2018, esto para garantizar,
            transparentar, informar y orientar correctamente a EL CLIENTE.
            <br />
            <br />
            EL CLIENTE acepta por falta de pago total o parcial de los servicios
            que ha contratado a través de “Marzah Travel” será causa suficiente
            de cancelación o rescisión del contrato y de los servicios
            contratados por EL CLIENTE con los diversos prestadores mencionados
            que pudieran ser de manera enunciativa más no limitativa: líneas
            aéreas, hoteles, transportistas terrestres, marítimos u operadores,
            etc. por lo que en este acto EL CLIENTE libera en todo momento a
            “Marzah Travel”, a sus accionistas, consejeros, afiliadas,
            subsidiarias, asesores, factores dependientes o partes relacionadas
            de cualquier responsabilidad que por su incumplimiento (DEL CLIENTE)
            pudiera corresponder.
            <br />
            <br />
            Los precios que ofrece “Marzah Travel”, no incluyen los siguientes
            conceptos:
            <br />
            <br />
            <ul>
              <li>Gastos de visado de entrada a cualquier país.</li>
              <li>Gastos de tramitación de pasaportes.</li>
              <li>
                Propinas de tipo personal a cualquier empleado ajeno a “MARZAH
                TRAVEL”.
              </li>
              <li>Exceso de equipaje.</li>
              <li>
                Gastos extras de ningún tipo que no estén debidamente
                especificados en los itinerarios.
              </li>
            </ul>
            <br />
            <br />
            POLÍTICAS DE RESERVACIÓN:
            <br />
            <br />
            <ul>
              <li>
                Las tarifas que aplican son válidas al momento de la cotización,
                para asegurar la tarifa cotizada, se debe generar el apartado o
                depósito completo del servicio. De lo contrario, puede existir
                variación por cambio de disponibilidad o tipo de cambio. La
                reserva será válida únicamente cuando un experto en ventas
                confirme el servicio por alguno de nuestros canales oficiales.
              </li>
              <li>
                Su número de confirmación le será enviado después de que haya
                efectuado el pago de su reservación, (anticipo o pago total).
                Hasta ese momento se considera una reservación confirmada.
              </li>
              <li>
                Las reservaciones de los servicios están sujetas a
                disponibilidad al momento de procesar su solicitud y no podrán
                ser garantizadas hasta haber recibido el pago total.
              </li>
              <li>
                En las reservaciones de hoteles y paquetes terrestres, antes de
                solicitar el pago, verificaremos disponibilidad con el
                proveedor; por lo que le enviaremos la confirmación dentro de
                las siguientes 24 horas
              </li>
              <li>
                El pago de los servicios se efectuará directamente por el
                cliente una vez establecida la relación comercial con “MARZAH
                TRAVEL”.
              </li>
              <li>
                Posterior a la reservación y confirmación, el cliente deberá
                imprimir el cupón correspondiente y presentarlo al momento de
                que haga el check in.
              </li>
              <li>
                El cliente deberá leer las políticas de cancelación, ya que
                cualquier cambio de reservación está sujeto a disponibilidad y
                re-cotización de tarifas y a las políticas del prestador de
                servicios o línea aérea. Deberá tener a la mano su número de
                reservación y contactar al área correspondiente de la empresa
                para cualquier aclaración.
              </li>
              <li>
                Los precios son por persona e incluyen los servicios que se
                indican en la descripción.
              </li>
            </ul>
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            POLÍTICAS DE PAGO:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul>
              <li>
                El monto total de su reservación, o el anticipo, pueden ser
                pagados mediante transferencia bancaria, pago en efectivo en
                sucursal o cargo a tarjeta, previa confirmación de la
                disponibilidad de los servicios.
              </li>
              <li>
                Aceptamos las siguientes tarjetas de crédito: Visa, Mastercard y
                American Express. El personal de la empresa con gusto le
                proporcionará los datos de las comisiones bancarias que aplican,
                así como los cargos bancarios en pagos diferidos.
              </li>
              <li>
                Las tarifas publicadas en nuestro sitio están cotizadas en
                diferentes tipos de moneda, los pagos los recibimos en Moneda
                Nacional en pesos mexicanos MXN. En otros tipos de moneda el
                monto de la transacción será convertido a Moneda Nacional MXN al
                tipo de cambio vigente en la fecha de la transacción. Si existe
                alguna diferencia por la fluctuación internacional o comisiones
                bancarias “Marzah Travel” no es responsable de estas
                fluctuaciones.
              </li>
              <li>
                Si el cliente requiere factura, podrá solicitarla al WhatsApp
                998 218 9740 y al correo info@marzahtravel.com, Únicamente se
                podrá hacer la factura en el mismo mes que se contrata el
                servicio.
              </li>
            </ul>
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            POLÍTICAS DE CANCELACIÓN:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul>
              <li>
                Las cancelaciones deberán ser informadas al personal de la
                empresa que lo esté atendiendo por escrito a través de correo
                electrónico o al WhatsApp 998 218 9740. Las políticas de Las
                cancelaciones varían de acuerdo con el servicio contratado.
                “MARZAH TRAVEL” actúa como intermediario entre el usuario y el
                prestador del servicio.
              </li>
            </ul>
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>PARA HOTELES:</h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul>
              <li>
                Las políticas de cancelación de los hoteles son específicas para
                cada hotel por lo que al momento de que usted elija el hotel
                podrá solicitar al personal de empresa las políticas de
                cancelación que apliquen en su caso.
              </li>
              <li>
                Las políticas de cancelación de los hoteles son específicas para
                cada hotel por lo que al momento de que usted elija el hotel
                podrá solicitar al personal de empresa las políticas de
                cancelación que apliquen en su caso.
              </li>
              <li>
                Los precios de los hoteles son por habitación con el régimen de
                comidas que haya solicitado.
              </li>
              <li>
                En paquetes donde se incluye alojamiento, en caso de existir
                algún problema de disponibilidad, se efectuará cambio en los
                hoteles elegidos y el o los hotel(es) que se reemplacen serán de
                categoría similar y dicho cambio será comunicado con la debida
                antelación.
              </li>
              <li>
                La hora de ingreso es a partir de las 15:00 hrs. del día
                contratado y finaliza a las 12:00 horas del último día fijado
                para la partida, en caso de llegar antes de las 15:00 horas es
                posible que su habitación no le sea otorgada en ese momento. Si
                requiere prolongar su estancia después de la hora de salida
                deberá notificarlo a la recepción y solicitar directamente con
                el hotel la estancia adicional.
              </li>
            </ul>
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            PARA TRANSPORTACIÓN TERRESTRE Y/O TOURS:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            Serán considerados como datos personales sensibles aquellos así
            dispuestos por la Ley Federal de Protección de Datos en Posesión de
            los Particulares, que de forma enunciativa más no limitativa, son
            los datos que forman parte de la intimidad del personal y cuya
            divulgación pone en riesgo o da origen a discriminación por aspectos
            de origen racial o étnico, estado de salud, información genética,
            creencias religiosas, filosóficas o morales, afiliación sindical,
            opiniones políticas y preferencias sexuales.
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            SERVICIOS AÉREOS:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul>
              <li>
                Las tasas de aeropuerto no están incluidas en los paquetes.
              </li>
              <li>
                Las tarifas aéreas son por persona, puede o no incluir los
                impuestos. Se especificará al momento de realizar su compra.
              </li>
              <li>
                Políticas de cancelación y penalización por cambios de fecha
                entrarán en vigor al momento de que los boletos sean emitidos y
                varían dependiendo de la línea aérea que realice el traslado. No
                importa la anticipación con la que se realice el cambio o la
                cancelación, en todo caso se deberá consultar con la línea aérea
                correspondiente.
              </li>
            </ul>
          </p>
          <h5 style={{ color: "#3764ab", fontSize: "30px" }}>
            CANCELACIÓN POR CAUSAS NO IMPUTABLES A LA EMPRESA:
          </h5>
          <p
            className="text-muted text-secondary"
            style={{ fontSize: "18px", textAlign: "justify" }}
          >
            <ul style={{ listStyleType: "lower-alpha" }}>
              <li>
                “Marzah Travel” actúa como agente intermediario entre el cliente
                y el prestador de los bienes y servicios que se publican en el
                sitio{" "}
                <a href="https://marzahtravel.com">https://marzahtravel.com</a>{" "}
                los servicios que sepromueven son: hospedaje de hoteles,
                transportación terrestre y tours, para lo cual “Marzah Travel”
                establece negociaciones comerciales con proveedores calificados
                y de con amplia reputación el mercado; no obstante lo anterior
                “Marzah Travel” no puede asumir ninguna responsabilidad con
                quienes compran servicios en la página
                <a href="https://marzahtravel.com">
                  https://marzahtravel.com
                </a>{" "}
                por actos u omisiones en los servicios de esos proveedores, ya
                que “Marzah Travel” no tiene representación legal ni control
                administrativo sobre los bienes, procedimientos, personal y
                equipo de esos proveedores.
              </li>
              <li>
                “Marzah Travel” no asumirá responsabilidad por ninguna
                reclamación, costo o gastos que surjan por heridas personales o
                de terceras personas, accidentes o deceso, pérdida o daños de
                pertenencias personales, pérdida de diversión, enojo,
                desilusión, angustia o frustración ya sea mental o física que
                resulte de lo que a continuación se menciona: a. Actos u
                omisiones de cualquiera otra persona que no sean empleados de
                “Marzah Travel”
              </li>
              <li>
                Enfermedad, robo, disputas laborales, fallas mecánicas,
                cuarentena, acciones gubernamentales, clima, desastres naturales
                o cualquier otra causa ajena al control directo de “Marzah
                Travel”.
              </li>
              <li>
                Incumplimiento del cliente en obtener la documentación requerida
                para su viaje como: pasaportes, visas y certificados o cualquier
                documento que es su responsabilidad tramitar, en En ese caso
                usted no tendrá derecho a ningún reembolso.
              </li>
              <li>
                Omisión de seguimiento de instrucciones por parte del cliente en
                horarios de salida de aeropuerto, hora y fecha de entrada y
                salida de hoteles, política de canje de cupones.
              </li>
              <li>
                Cancelación o cambio por cualquier motivo de los servicios de
                viaje ofrecidos. Nos reservamos el derecho de cancelar o cambiar
                los servicios de viaje a nuestra discreción, pero se tratará de
                sustituirlos con servicios comparables. En caso de cancelación
                “Marzah Travel” tendrá la responsabilidad de reembolsar el monto
                total del dinero pagado.
              </li>
              <li>
                “Marzah Travel” mantiene actualizada la base de datos de sus
                proveedores respecto a precios y condiciones de los servicios,
                no obstante lo anterior existe la posibilidad de que los
                proveedores realicen modificaciones o proporcionen información
                errónea respecto a la vigencia de algunas tarifas; en caso de
                cualquier cambio de tarifa, ya sea menor o mayor, un experto en
                ventas se pondrá en contacto con usted para informarle esta
                modificación y que usted esté en libertad de aceptar o no, la
                situación que se presente respecto de la reservación que
                realizó, no omitimos mencionar que “Marzah Travel” se deslinda
                expresamente y a sus proveedores de cualquier responsabilidad o
                pago de indemnización por esa cancelación.
              </li>
              <li>
                Las fotografías mostradas en el portal son representativas y no
                garantiza que a su llegada todo sea exactamente igual como aquí
                se puede ver.
              </li>
              <li>
                La categoría de las estrellas asignada a los hoteles y
                servicios, están basados en la interpretación de “Marzah Travel”
                y puede diferir de las categorías reportadas en otros lugares.
              </li>
              <li>
                La descripción de los servicios de viaje son informativas y no
                garantizan que serán exactamente iguales a su llegada.
              </li>
              <li>
                Cualquier reclamación deberá hacerse por escrito al correo
                electrónico al personal de la empresa debiendo ser recibida a
                más tardar 15 días después del regreso de su viaje. Pasado ese
                lapso de tiempo la empresa no recibirá reclamo alguno.
              </li>
            </ul>
          </p>
          <p style={{ fontSize: "18px", textAlign: "justify" }}>
            ¡Aceptamos todas las formas de pago! Efectivo, tarjetas de crédito y
            débito, transferencias y pagos digitales. ¡Elige la que te acomoda!
            <br />
            <br />
            Aceptamos todas las formas de pago. Su transacción se realiza de
            manera segura a través de Openpay, garantizando la confidencialidad
            y protección de sus datos.
          </p>
          <img src={openpay} width={300} alt="" />
          <p
            style={{ fontSize: "18px", textAlign: "justify", color: "#3764ab" }}
          >
            Marzah Travel AGENCIA DE VIAJES”
            <br />
            <br />
            TELÉFONO: <span style={{ color: "#3764ab" }}>998 218 9740</span>
            <br />
            <br />
            WHATSAPP: <span style={{ color: "#3764ab" }}>998 218 9740</span>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={"btnCloseModal w-auto"}
            onClick={() => setOpenModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
